import { ImageCard } from '@/components/ImageCard/ImageCard';
import type { ImageInterface } from '@/types/homepage.types';

export const RenderImage = ({
  externalURL,
  imageURL,
  imageAltText,
  description,
}: ImageInterface) => {
  if (externalURL)
    return (
      <a
        className='hover:opacity-80'
        href={externalURL}
        rel='noopener noreferrer'
        target='_blank'
        aria-label={`Link to ${imageAltText} (opens in a new tab)`}
      >
        <ImageCard imageURL={imageURL} imageAltText={imageAltText} description={description} />
      </a>
    );
  return <ImageCard imageURL={imageURL} imageAltText={imageAltText} description={description} />;
};
